export default {
      id: "visibilityOff-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#visibilityOff-usage",
      toString: function () {
        return this.url;
      }
    }